import { useState } from 'react';
import './AuthModal.css';

export default function AuthModal({ isOpen, onClose, onSignIn, onEmailSignIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleEmailSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!email.trim() || !password) {
      setError('Please enter your email and password.');
      return;
    }
    if (!onEmailSignIn) {
      setError('Email sign-in is not available.');
      return;
    }

    setSubmitting(true);
    try {
      const { error: signInError } = await onEmailSignIn(email.trim(), password);
      if (signInError) {
        throw new Error('Failed to sign in.');
      }
      setEmail('');
      setPassword('');
      onClose();
    } catch (err) {
      setError('Failed to sign in.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="auth-modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="auth-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="auth-modal-header">
          <h2 id="auth-modal-title">Sign in to continue</h2>
          <p>Log in or create an account to generate motion graphics.</p>
        </header>

        <button type="button" className="auth-modal-google" onClick={onSignIn}>
          <img src="/google.svg" alt="Google" />
          <span>Continue with Google</span>
        </button>

        <div className="auth-modal-divider">
          <span>or</span>
        </div>

        <form className="auth-modal-form" onSubmit={handleEmailSubmit}>
          <label className="auth-modal-label">
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@company.com"
            />
          </label>
          <label className="auth-modal-label">
            Password
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••"
            />
          </label>
          {error && <div className="auth-modal-error">{error}</div>}
          <button type="submit" className="auth-modal-email" disabled={submitting}>
            {submitting ? 'Signing in...' : 'Sign in with email'}
          </button>
        </form>

        <footer className="auth-modal-footer">
          <p>
            By continuing you agree to our{' '}
            <a href="/terms" target="_blank" rel="noreferrer">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="/privacy" target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
            .
          </p>
        </footer>
      </div>
    </div>
  );
}
